<app-dialog-close-button class="close-button" (closed)="close()"></app-dialog-close-button>
<div vng-dialog-title class="text-center">
  <strong>Are you sure you want to make this your primary payment method?</strong>
</div>

<div>
  <span style="display:flex; justify-content:center; align-items:center" class="mb-small">
    <svg-icon-sprite *ngIf="paymentMethod.brand === 'visa'" width="28px" height="17px" src="icon-visa"> </svg-icon-sprite>
    <svg-icon-sprite *ngIf="paymentMethod.brand === 'mastercard'" width="28px" height="17px" src="icon-mastercard"> </svg-icon-sprite>
    ****{{ paymentMethod.cardLastFour }}
  </span>
</div>

<vng-dialog-content>
  <vng-divider class="mb-2"></vng-divider>
</vng-dialog-content>

<vng-dialog-actions align="center" class="top-space mb-small" style="display:flex; justify-content:center; align-items:center; gap:15px">
  <button (click)="makePrimary(paymentMethod)" [disabled]="disabled" vng-button variant="primary">
    Make Primary
  </button>
  <button (click)="close()" vng-button variant="secondary">Cancel</button>
</vng-dialog-actions>
